/** Shopify CDN: Minification failed

Line 9:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 10:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 16:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 22:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet

**/
class CartLink extends HTMLElement {
  constructor() {
    super();

    this.itemsCount = this.querySelector('items-count');
  }

  connectedCallback() {
    this.unsubscribe = window.theme.cart.store.subscribe((state) => {
      this.itemsCount.innerHTML = state.products.item_count;
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }
}
customElements.define('cart-link', CartLink);
